import { render, staticRenderFns } from "./FormPFTS.vue?vue&type=template&id=2c40907e&scoped=true"
import script from "./FormPFTS.vue?vue&type=script&lang=js"
export * from "./FormPFTS.vue?vue&type=script&lang=js"
import style0 from "./FormPFTS.vue?vue&type=style&index=0&id=2c40907e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c40907e",
  null
  
)

export default component.exports